<template>
  <div class="teacher_detail">
    <div class="tpy_blur">
      <!-- 内容 -->
      <div class="main">
        <!-- 面包屑 -->
        <div class="breadcrumb m">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/school'}">科创培训</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/teacher'}">讲师列表</el-breadcrumb-item>
            <el-breadcrumb-item>讲师详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 顶部信息 -->
        <div class="detail_top m">
          <div class="left_info">
            <div class="img">
              <img v-if="params.speaker_headPath" :src="params.speaker_headPath" alt />
              <img v-else src="@/assets/img/common/default_head.png" alt />
            </div>
            <div class="txt">
              <h3>{{params.speaker}}</h3>
              <ul>
                <li>{{params.speaker_synopsis}}</li>
                <li>研究领域：{{params.technique_type_name}}</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 标签页 -->
        <div class="tabs m">
          {{tabsIndex}}
          <dl>
            <template v-for="(item,idx) in tab">
              <dd :class="{active:tabsIndex === item.key}" @click="tabsSwitchover(item,idx)" v-if="params[item.key]">{{item.name}}</dd>
            </template>
            <!-- <dd :class="{active:tabsIndex === 0}" @click="tabsSwitchover(0)">个人简介</dd>
            <dd :class="{active:tabsIndex === 1}" @click="tabsSwitchover(1)">获奖荣誉</dd>
            <dd :class="{active:tabsIndex === 2}" @click="tabsSwitchover(2)">科研项目</dd>
            <dd :class="{active:tabsIndex === 3}" @click="tabsSwitchover(3)">发表论文</dd>
            <dd :class="{active:tabsIndex === 4}" @click="tabsSwitchover(4)">专著教材</dd>
            <dd :class="{active:tabsIndex === 5}" @click="tabsSwitchover(5)">精品课程</dd> -->
          </dl>
        </div>
        <!-- 详情内容 -->
        <div class="detail_content m">
          <ul>
            <li v-if="params.synopsis" id="synopsis">
              <h4 class="title">个人简介</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.synopsis"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_honor" id="te_honor">
              <h4>获奖荣誉</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_honor"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_project" id="te_project">
              <h4>科研项目</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_project"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_paper" id="te_paper">
              <h4>发表论文</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_paper"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_book" id="te_book">
              <h4>专著教材</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_book"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_activity" id="te_activity">
              <h4>教学活动</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_activity"></dd>
                </dl>
              </div>
            </li>
            <li v-if="params.te_fine_class" id="te_fine_class">
              <h4>精品课程</h4>
              <div class="details">
                <dl>
                  <dd v-html="params.te_fine_class"></dd>
                </dl>
              </div>
            </li>
          </ul>
        </div>
        <!-- 课程 -->
        <div class="teacher_course_box m">
          <h3 class="teacher_course_tit">他的课程</h3>
          <div class="teacher_course_content">
            <course :list="list" />
            <myPage :layerpageinfo="layerpageinfo" @pageChange="getFrontColleges" v-if="layerpageinfo.total"></myPage>
          </div>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
import course from "@/components/list/hz_school/course/list.vue";
import myPage from "@/components/myPage/myPage.vue";
export default {
  components: {
    course,
    myPage
  },
  data() {
    return {
      dialogVisible: false,
      params: {},
      project: [],
      tabsTop: 0,
      tabsIndex: '',
      list: [],
      tab:[
        {
          name:'个人简介',
          key:'synopsis'
        },
        {
          name:'获奖荣誉',
          key:'te_honor'
        },
        {
          name:'科研项目',
          key:'te_project'
        },
        {
          name:'发表论文',
          key:'te_paper'
        },
        {
          name:'专著教材',
          key:'te_book'
        },
        {
          name:'教学活动',
          key:'te_activity'
        },
        {
          name:'精品课程',
          key:'te_fine_class'
        }
      ],
      layerpageinfo: {
        pageNo: 1,
        total: 0,
        pageSize: 3
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 开启滚动监听
      document.addEventListener("scroll", this.scrollListener);
    });
  },
  created() {
    //页面加载时位置为定顶部
    window.scrollTo(0, 0);
    this.getData(); //个人资料
    this.getFrontColleges(); //课程
  },
  //页面销毁前执行
  beforeDestroy() {
    if (document.removeEventListener) {
      document.removeEventListener("scroll", this.scrollListener);
    } else {
      document.detachEvent("scroll", this.scrollListener);
    }
  },
  methods: {
    // 获取热门课程
    getFrontColleges() {
      let params = Object.assign({}, this.layerpageinfo, {
        co_college: this.$route.query.id,
        type: "HZCollegeTypeCourse"
      });
      this.api.getFrontColleges(params).then(res => {
        this.list = res.obj.list || [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    //滚动监听
    scrollListener() {
      //tabs 距离可视区域最顶部的高
      this.tabsTop = document.querySelector(".tabs").offsetTop;
      //是否固定tabs栏
      if (document.documentElement.scrollTop >= this.tabsTop) {
        document.querySelector(".tabs dl").style.position = "fixed";
      } else {
        document.querySelector(".tabs dl").style.position = "relative";
      }
      //所有内容列表遍历判断tabs栏显示选中
      document.querySelectorAll(".detail_content>ul>li").forEach((item, i) => {
        if (document.documentElement.scrollTop >= item.offsetTop - 50) {
          this.tabsIndex = i;
        }
      });
    },
    //点击tabs
    tabsSwitchover(item,index) {
      this.tabsIndex = item.key;
      let dom = document.getElementById(item.key);
      console.log(dom);
      console.log(dom.offsetTop)
       window.scrollTo(0, dom.offsetTop - 50);
    },
    //联系华转客服
    openZxDialog() { 
      window.open(
        "http://p.qiao.baidu.com/cps/chat?siteId=12321420&userId=25956497",
        "免费咨询",
        "alwaysRaised=yes,width=800,height=600,location=no,menubar=no,toolbar=no,status=no"
      );
    },

    //个人信息
    getData() {
      let params = {
        id: this.$route.query.id
      };
      return this.api.getFrontColleges(params).then(
        res => {
          if (res.error.err_code !== 0) return;
          this.params = res.obj.list[0] || null;
        }
      );
    }
  }
};
</script>

<style lang="scss">
.teacher_detail {
  background: #f0f2f5;
  .my_header {
    background: #fff;
  }
  .breadcrumb {
    padding: 20px 0;
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #ff733c;
    }
  }

  //顶部信息
  .detail_top {
    background: #fff;
    height: 207px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 30px 17px;
    box-sizing: border-box;
    //左边信息
    .left_info {
      display: flex;
      align-items: center;
      .img {
        width: 110px;
        height: 110px;
        margin: 0 30px 0 0;
        flex:none;
      }
      .img img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .txt h3 {
        font-size: 16px;
        font-weight: bold;
        color: #343434;
        margin-bottom: 10px;
      }

      .txt {
        ul {
          li {
            font-size: 12px;
            color: rgba(165, 170, 176, 1);
            line-height: 26px;
          }
        }
      }
    }
    //右边按钮
    .right_btn {
      display: flex;
      .button {
        height: 34px;
        line-height: 34px;
        padding: 0 22px;
        margin-left: 14px;
        border: 1px solid #fff;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
      }
      .button:hover {
        background-color: #fff;
        color: #ff733c;
      }
      .button.active {
        background-color: #fff;
        color: #ff733c;
      }
    }
  }

  //标签页
  .tabs {
    height: 50px;

    dl {
      position: relative;
      top: 0;
      z-index: 999;
      width: 1200px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }
    dl dd {
      font-size: 14px;
      color: #4b5062;
      line-height: 50px;
      cursor: pointer;
      position: relative;
      margin-right: 90px;
    }
    dl dd.active {
      color: #0c007a;
    }
    dl dd.active:after {
      position: absolute;
      content: "";
      width: 24px;
      height: 2px;
      background-color: #0c007a;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
    }
  }

  //详情内容
  .detail_content {
    background: #fff;
    border: 1px solid #e7e9ec;
    padding: 40px;
    box-sizing: border-box;
    margin-bottom: 50px !important;
    margin-top: 10px !important;
    word-break: break-all;
    ul li {
      box-sizing: border-box;
      margin-bottom: 38px;
      h4 {
        font-size: 14px;
        color: #4b5062;
        position: relative;
        padding-left: 19px;
        font-weight: bold;
        margin-bottom: 19px;
      }
      h4:before {
        position: absolute;
        content: "";
        width: 9px;
        height: 9px;
        border: 2px solid #ff733c;
        border-radius: 50%;
        top: 0;
        bottom: 0;
        margin: auto 0;
        box-sizing: border-box;
        left: 0;
      }
      .details {
        padding-left: 19px;
      }
      // .details dl dd {
      //   font-size: 14px;
      //   color: #9fa4b1;
      //   margin-bottom: 6px;
      //   line-height: 20px;
      // }
      // .details dl dd:last-child {
      //   margin-bottom: 0;
      // }
      .details .details_item {
        margin-top: 28px;
        span {
          font-size: 14px;
          color: #4b5062;
        }
        div {
          font-size: 14px;
          color: #9fa4b1;
          margin-top: 18px;
          line-height: 24px;
        }
      }
      .details .project_item {
        padding-bottom: 19px;
        margin-bottom: 19px;
        border-bottom: 1px solid #eee;
        p {
          font-size: 14px;
          color: #9fa4b1;
        }
        p span {
          display: inline-block;
          margin-left: 30px;
        }
        div {
          font-size: 14px;
          color: #9fa4b1;
          margin-top: 20px;
          line-height: 24px;
        }
      }
      .details .project_item:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
      }
    }
    /* 浏览记录 */
    .record_box {
      padding: 30px 20px;
      max-height: 240px;
      .record_item {
        display: flex;
        margin-bottom: 30px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 20px;
        }
        .record {
          display: flex;
          align-items: center;
        }
      }
    }
    .record_box::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    .record_box::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      /*box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      background: #aaaaaa;
    }
    .record_box::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      /*box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      border-radius: 10px;
      background: #f5f5f5;
    }
  }
  .teacher_course_box {
    padding: 0 30px 30px;
    background: #fff;
    margin-top: 10px;
    box-sizing: border-box;
    .teacher_course_tit {
      font-size: 22px;
      font-weight: bold;
      color: rgba(75, 80, 98, 1);
      height: 82px;
      line-height: 82px;
    }
    .teacher_course_content {
    }
  }
  .footer{
    margin-top: 40px;
  }
}
</style>
